module.exports = __webpack_public_path__ + "img/mark_d.9e13faba.png";